import ActionsForm from '@/shared/mixins/actionsForm'
import ModalAddPhone from './modal/phonemodal.vue'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'CrmDetailsPhone',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    phones: {
      type: Array,
      default: null
    },
    boardArchived: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: null,
      form: null
    }
  },
  components: {
    ModalAddPhone
  },
  methods: {
    onLoad () {},
    onAddPhone () {
      this.$refs.ModalAddPhone.showModal()
    },
    onReload () {
      this.$emit('Reload')
    },
    toastInfo () {
      toast.info('Esta funcionalidade ainda não está disponível no seu nxCoop.')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/phones/phone.js